import { render, staticRenderFns } from "./mainFour.vue?vue&type=template&id=3142b386&scoped=true&"
import script from "./mainFour.vue?vue&type=script&lang=js&"
export * from "./mainFour.vue?vue&type=script&lang=js&"
import style0 from "./mainFour.vue?vue&type=style&index=0&id=3142b386&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3142b386",
  null
  
)

export default component.exports